import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(value, currency = 'INR') {
  const num = Number(value || 0);
  if (currency === 'INR') {
    return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 2 }).format(num);
}

export function formatDate(date, opts) {
  if (!date) return '—';
  return new Date(date).toLocaleDateString('en-IN', opts ?? { day: '2-digit', month: 'short', year: 'numeric' });
}

export function getStatusColor(status) {
  const map = {
    PENDING: 'bg-yellow-100 text-yellow-700', CONFIRMED: 'bg-sky-100 text-sky-700',
    PROCESSING: 'bg-blue-100 text-blue-700', PAID: 'bg-green-100 text-green-700',
    PACKED: 'bg-violet-100 text-violet-700',
    SHIPPED: 'bg-indigo-100 text-indigo-700',
    OUT_FOR_DELIVERY: 'bg-amber-100 text-amber-700',
    DELIVERED: 'bg-emerald-100 text-emerald-700', CANCELLED: 'bg-red-100 text-red-700',
    RETURN_INITIATED: 'bg-orange-100 text-orange-700', RETURNED: 'bg-orange-100 text-orange-700',
    EXPIRED: 'bg-gray-100 text-gray-500', REFUNDED: 'bg-orange-100 text-orange-700',
    // lowercase aliases
    pending: 'bg-yellow-100 text-yellow-700', confirmed: 'bg-sky-100 text-sky-700',
    paid: 'bg-green-100 text-green-700', processing: 'bg-blue-100 text-blue-700',
    packed: 'bg-violet-100 text-violet-700',
    shipped: 'bg-indigo-100 text-indigo-700',
    out_for_delivery: 'bg-amber-100 text-amber-700',
    delivered: 'bg-emerald-100 text-emerald-700', cancelled: 'bg-red-100 text-red-700',
  };
  return map[status] ?? 'bg-gray-100 text-gray-600';
}